import { Box, Button, Grid, Paper } from '@mui/material';
import { useExportUsersDataToCSVMutation, useGetGeneralAnalyticsQuery } from 'api/services/dataEndpoints';
import { Item, MyBox } from './GeneralStat.styles';

const GeneralStat:React.FC = () => {
  const { data, isLoading, isError } = useGetGeneralAnalyticsQuery({});
  const [exportUsersCSV, { isLoading: isExporting }] = useExportUsersDataToCSVMutation();

  const getMostLeavedStepText = (obj: { stage: string; count: number } | undefined) => {
    if (!obj) {
      return '-';
    }
    return `${obj.stage} (${obj.count} times)`;
  };

  const handleDownload = async () => {
    try {
      const blob = await exportUsersCSV().unwrap();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      a.download = 'users_data.csv';

      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error('CSV export failed', e);
    }
  };

  return (
      <Grid container>

          <MyBox>
            <Item elevation={2}>
              Total users: {data?.totalUsers || '-'}
            </Item>
          </MyBox>
          <MyBox>
            <Item elevation={2}>
              Total messages: {data?.totalMessages || '-'}
            </Item>
          </MyBox>
          <MyBox>
            <Item elevation={2}>
              Most leaved step: {getMostLeavedStepText(data?.mostLeavedStep)}
            </Item>
          </MyBox>
          <Button
            variant="contained"
            size="small"
            onClick={handleDownload}
            disabled={isExporting}
          >
            {isExporting ? 'Exporting...' : 'Export user data to CSV'}
          </Button>
      </Grid>

  );
};

export default GeneralStat;
